import React from 'react';
import styles from './BindedItem.module.css';
import Button from '../../Button/Button';

const BindedItem = ({
	api,
	rule_id,
	item_id,
	itemDict,
	getRules,
	setErrorApi,
	deleteEndpoint
}) => {

	const [subModalOpen, setSubModalOpen] = React.useState(false);

	const deleteBindedItem = async () => {
		try {
			await api.delete(`${deleteEndpoint}${rule_id}`);
			if (typeof getRules === 'function') getRules();
		} catch (e) {
			if (typeof setErrorApi === 'function') {
				setErrorApi(e.response?.data?.detail || e.response?.data?.message || 'Неизвестная ошибка');
			}
		}
	};

	return (
		<div className={styles.content}>
			<div className={styles.bindedProf}>
				<div className={styles.professionName}>
					<span className={styles.clampedText}>
						{itemDict[item_id] ?? `id ${item_id}`}
					</span>
				</div>
				<div className={styles.iconBox}>
					<button className={styles.iconButton} onClick={() => setSubModalOpen(!subModalOpen)}>
						<img className={styles.iconImage} src="/icons/delete-icon.svg" alt="delete"/>
					</button>

				</div>
			</div>
			{subModalOpen && <div className={styles.submodal}>
				<Button className={styles.button_submodal} onClick={deleteBindedItem}>
										Удалить
				</Button>
				<Button className={styles.button_submodal} onClick={() => setSubModalOpen(false)}>
										Отмена
				</Button>
			</div>}
		</div>
	);
};

export default BindedItem;